import { nanoid } from '@reduxjs/toolkit';

export const cacheTags = {
  providerConnection: `providerConnection${nanoid()}`,
  accountInfo: `accountInfo${nanoid()}`,
  rollups: `rollups${nanoid()}`,
};
